(() => {
  function initCatalog(root = document) {
    root.querySelectorAll(".dtw-catalog").forEach((catalog) => {
      if (catalog.dataset.initialized) return;
      catalog.dataset.initialized = "true";
      let category = "all";
      const search = catalog.querySelector("[data-dtw-search]");
      const filter = () => {
        let visible = 0;
        catalog.querySelectorAll("[data-dtw-card]").forEach((card) => {
          card.hidden =
            !(category === "all" || card.dataset.category === category) ||
            !card.dataset.title
              .toLowerCase()
              .includes(search.value.trim().toLowerCase());
          if (!card.hidden) visible++;
        });
        catalog.querySelector(".dtw-no-results").hidden = visible > 0;
      };
      catalog.querySelectorAll("[data-dtw-filter]").forEach((button) =>
        button.addEventListener("click", () => {
          category = button.dataset.dtwFilter;
          catalog
            .querySelectorAll("[data-dtw-filter]")
            .forEach((item) =>
              item.setAttribute("aria-pressed", String(item === button)),
            );
          filter();
        }),
      );
      search.addEventListener("input", filter);
    });
  }
  function initPackages(root = document) {
    root.querySelectorAll("[data-dtw-package-form]").forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = "true";
      const quantity = form.querySelector('[name="quantity"]');
      const decrease = form.querySelector('[data-dtw-quantity-step="-1"]');
      const normalize = () => {
        const value = Number(quantity.value);
        quantity.value = String(
          Number.isFinite(value)
            ? Math.min(Number.MAX_SAFE_INTEGER, Math.max(1, Math.floor(value)))
            : 1,
        );
      };
      const update = () => {
        const selected = form.querySelector('[name="id"]:checked');
        if (!selected) return;
        const button = form.querySelector('[type="submit"]');
        button.disabled = selected.dataset.available !== "true";
        button.textContent = button.disabled
          ? "SAMPLE PACKAGE — COMING SOON"
          : "ADD PACKAGE TO CART";
        const validQuantity = Math.max(
          1,
          Math.floor(Number(quantity.value) || 1),
        );
        decrease.disabled = validQuantity <= 1;
        form.querySelector("[data-dtw-total]").textContent =
          new Intl.NumberFormat(document.documentElement.lang || "en-US", {
            style: "currency",
            currency: form.dataset.currency,
          }).format((Number(selected.dataset.price) * validQuantity) / 100);
        const url = new URL(window.location.href);
        url.searchParams.set("variant", selected.value);
        window.history.replaceState({}, "", url);
      };
      form.querySelectorAll("[data-dtw-quantity-step]").forEach((control) => {
        control.addEventListener("click", () => {
          normalize();
          quantity.value = String(
            Math.max(
              1,
              Number(quantity.value) + Number(control.dataset.dtwQuantityStep),
            ),
          );
          quantity.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
      quantity.addEventListener("change", normalize);
      quantity.addEventListener("blur", () => {
        normalize();
        update();
      });
      form.addEventListener("submit", normalize);
      form.addEventListener("change", update);
      quantity.addEventListener("input", update);
      update();
    });
  }
  initCatalog();
  initPackages();
  document.addEventListener("shopify:section:load", (event) => {
    initCatalog(event.target);
    initPackages(event.target);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape")
      document.querySelector(".dtw-mobile-menu")?.removeAttribute("open");
  });
})();
